<mbs-card
  class="mb-3 h-auto"
  [customClasses]="'bg-light border-radius-xl-important h-auto'"
  [hasPadding]="false"
  [innerBordered]="false"
  [size]="size.xs">
  <mbs-card-group class="w-100 p-3">
    <div class="h5 fw-bold mb-1">{{ 'wizards:generic.backupDestination' | i18next }}</div>
    @if (selectedDestination() || loadingDestinations()) {
      <mbs-select
        #destinationSelect="ngModel"
        [bindLabel]="'DisplayName'"
        [clearable]="false"
        [disabledSelf]="loadingDestinations() || loadingPlans()"
        [hideSelected]="true"
        [id]="'backup-destination-select'"
        [items]="destinationItems"
        [loading]="loadingDestinations() || loadingPlans()"
        [ngModel]="selectedDestination()"
        [placeholder]="'wizards:generic.selectBackupDestination' | i18next"
        [required]="!loadingDestinations() && !loadingPlans()"
        [searchable]="false"
        (change)="backupDestinationChangeHandler()"
        (ngModelChange)="selectedDestination.set($event)">
      </mbs-select>
    }
    @if (!selectedDestination() && !(loadingDestinations() || loadingDestinations())) {
      <mbs-alert
        class="mb-0 mt-2"
        [icon]="true"
        [type]="mbsPopupType.info">
        {{ 'wizards:generic.selectBackupDestinationVoid' | i18next }}
      </mbs-alert>
    }
  </mbs-card-group>

  <mbs-card-group class="w-100 p-3">
    <div class="h5 fw-bold mb-1">{{ 'wizards:generic.backupPlan' | i18next }}</div>
    @if (selectedPlan() || loadingPlans()) {
      <mbs-select
        #planSelect="ngModel"
        [bindLabel]="'displayName'"
        [clearable]="false"
        [disabledSelf]="loadingPlans() || loadingPoints()"
        [hideSelected]="true"
        [id]="'backup-plans-select'"
        [items]="planItems"
        [loading]="loadingPlans() || loadingPoints()"
        [ngModel]="selectedPlan()"
        [placeholder]="'wizards:generic.selectBackupPlan' | i18next"
        [required]="!loadingPlans() && !loadingPoints()"
        [searchable]="false"
        (change)="backupPlanChangeHandler()"
        (ngModelChange)="selectedPlan.set($event)">
      </mbs-select>
    }
    @if (!selectedPlan() && !(loadingPlans() || loadingPoints())) {
      <mbs-alert
        class="mb-0 mt-2"
        [icon]="true"
        [type]="mbsPopupType.info">
        <span class="d-block">{{ 'wizards:generic.selectBackupPlanVoid' | i18next }}</span>

        @if (fromToStepData()?.restoreTo === restoreToVariants.current) {
          <span class="d-block">{{ 'wizards:generic.currentComputerExc' | i18next }}</span>
        } @else if (fromToStepData()?.restoreTo === restoreToVariants.different) {
          <span class="d-block">{{ 'wizards:generic.plansExcDiff' | i18next }}</span>
        } @else {
          <span class="d-block">{{ 'wizards:generic.plansExc' | i18next }}</span>
        }
      </mbs-alert>
    }
  </mbs-card-group>

  @if (selectedPlan() || loadingDestinations() || loadingPlans() || loadingPoints()) {
    <mbs-card-group class="w-100 p-3">
      <div class="h5 fw-bold mb-1">{{ 'wizards:restore_point_title' | i18next }}</div>
      <mbs-form-group class="mb-0">
        <mbs-radio
          name="restorePoint"
          [descriptionClasses]="'mt-1'"
          [descriptionOutside]="false"
          [id]="'restore-point-latest-radio'"
          [label]="'wizards:latest_version_label' | i18next"
          [ngModel]="restorePointType()"
          [value]="restoreType.LatestVersion"
          (change)="backupPointChangeHandler()"
          (ngModelChange)="restorePointType.set($event)">
          <ng-template radioDescription>
            <span class="text-sm">{{ 'wizards:latest_version_subtitle' | i18next }}</span>
          </ng-template>
        </mbs-radio>
        <div
          class="mt-2"
          placement="top-start"
          [disableTooltip]="!selectedPlan() || selectedPlan().isNBF"
          [ngbTooltip]="'wizards:generic.selectRestorePointNotAvailable' | i18next">
          <mbs-radio
            name="restorePoint"
            [descriptionClasses]="'mt-1'"
            [descriptionOutside]="false"
            [disabledSelf]="loadingPoints() || !selectedPlan()?.isNBF || existFiltersPoints()"
            [id]="'restore-point-radio'"
            [label]="'wizards:select_restore_point_label' | i18next"
            [ngModel]="restorePointType()"
            [value]="restoreType.PointInTime"
            (change)="backupPointChangeHandler()"
            (ngModelChange)="restorePointType.set($event)">
            <ng-template radioDescription>
              <span class="text-sm d-block mb-3">{{ 'wizards:select_restore_point_subtitle' | i18next }}</span>
              <mbs-select
                #pointSelect="ngModel"
                [bindLabel]="'label'"
                [clearable]="false"
                [disabledSelf]="restorePointType() !== restoreType.PointInTime || loadingPoints()"
                [hideSelected]="true"
                [id]="'backup-points-select'"
                [items]="pointItems"
                [loading]="loadingPoints()"
                [ngModel]="selectedPoint()"
                [placeholder]="'wizards:generic.selectRestorePoint' | i18next"
                [required]="restorePointType() === restoreType.PointInTime && !loadingPoints()"
                [searchable]="false"
                (change)="backupPointChangeHandler()"
                (ngModelChange)="selectedPoint.set($event)">
              </mbs-select>
            </ng-template>
          </mbs-radio>
        </div>
      </mbs-form-group>
    </mbs-card-group>
  }

  @if (selectedPoint()?.isEncrypted) {
    <mbs-card-group
      class="w-100 p-3"
      [attr.data-e2e]="elementsSelector.name.passwordBlock">
      <div class="h5 fw-bold mb-1">{{ 'wizards:password_encryption_pass_label' | i18next }}</div>
      @if (!isProvider && passwordRecoveryEnabled && showRecoveryInfo()) {
        <mbs-alert
          class="mb-1"
          [icon]="true"
          [type]="mbsPopupType.warning">
          {{ 'wizards:recoveryAlertFirst' | i18next }}
          <a [href]="'mailto:' + providerEmail">{{ providerEmail }}</a>
          {{ 'wizards:recoveryAlertSecond' | i18next }}
        </mbs-alert>
      }

      <mbs-input-password
        [id]="'add-network-share-password-input'"
        [label]="'wizards:addNetworkSharePass' | i18next"
        [ngModel]="password()"
        [placeholder]="'wizards:addNetworkSharePassPlaceholder' | i18next"
        (input)="passwordInputHandler($event)"
        (ngModelChange)="password.set($event)"></mbs-input-password>

      @if (allowedRecovery && selectedPlan()?.isNBF && !isUnix) {
        <mbs-form-group class="mt-3">
          <div class="mb-2">
            <app-password-recovery-handler
              [backupVersionUpdated]="backupVersionUpdated"
              [hid]="fromToStepData()?.fromComputer?.hid"
              [passwordControl]="passwordControlFacade"
              [resultPoint]="{
                path: selectedPoint()?.path,
                restorePoint: selectedPoint()?.restorePointId
              }"></app-password-recovery-handler>
          </div>
        </mbs-form-group>
      }

      @if (selectedPoint()?.encryptionPasswordHint) {
        <mbs-form-group
          class="mt-3 mb-0"
          [attr.data-e2e]="elementsSelector.name.passwordHintBlock">
          <mbs-button
            type="primary"
            [isCtrl]="true"
            (click)="showPasswordHintChangeHandler()">
            {{ 'wizards:pass_hint_btn_text' | i18next: { state: showHint ? 'Hide' : 'Show' } }}
          </mbs-button>

          @if (showHint && selectedPoint()?.encryptionPasswordHint) {
            <div
              class="fw-bold"
              [attr.data-e2e]="elementsSelector.name.passwordHintText">
              {{ selectedPoint().encryptionPasswordHint }}
            </div>
          }
        </mbs-form-group>
      }
    </mbs-card-group>
  }
</mbs-card>
